import { render, staticRenderFns } from "./ModalCidadao.vue?vue&type=template&id=8e42e29a&scoped=true"
import script from "./ModalCidadao.vue?vue&type=script&lang=js"
export * from "./ModalCidadao.vue?vue&type=script&lang=js"
import style0 from "./ModalCidadao.vue?vue&type=style&index=0&id=8e42e29a&prod&scoped=true&lang=scss"
import style1 from "./ModalCidadao.vue?vue&type=style&index=1&id=8e42e29a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e42e29a",
  null
  
)

export default component.exports